var React = require("react");
var Radium = require("radium");
var Sign = require("./Sign.jsx");
var Checkbox = require("../Checkbox/Checkbox.jsx");

var style = {
	wrapper: {
		fontFamily: 'arial, sans-serif',
		fontWeight: 'bold',
		cursor: 'pointer',
		transition: 'all 0.2s linear'
	},

	title: {
		position: 'relative',
		top: 8,
		fontSize: 10,
		margin: '0px 10px',
		textTransform: 'lowercase'
	},

	base: {
		color: "#03a6dc",
		borderRadius: 1000,
		border: 'solid 0.0627em #666',
		display: 'inline-block',
		position: 'relative',
		transition: 'all 0.2s ease-in-out',
		height: '1.3em',
		top: '0.12em',
		width: '2.2em'
	},

	checked: {
		backgroundColor: 'currentColor',
		border: 'solid 0.0627em currentColor'
	},

	disabled: {
		opacity: 0.5
	}
};

module.exports = Radium(
	React.createClass({
		displayName: "Toggle",

		propTypes: {
			showTitle: React.PropTypes.bool,
			titleOn: React.PropTypes.string,
			titleOff: React.PropTypes.string,
			label: React.PropTypes.string,
			checked: React.PropTypes.bool,
			disabled: React.PropTypes.bool,
			onChange: React.PropTypes.func.isRequired
		},

		getDefaultProps: function() {
			return {
				showTitle: false,
				titleOn: "on",
				titleOff: "off"
			};
		},

		getTitle: function() {
			var me = this, props = me.props, title;

			if (props.checked) {
				title = props.titleOn;
			} else {
				title = props.titleOff;
			}

			return (
				<span style={me.props.disabled ? [style.title, style.disabled] : style.title}>
					{title}
				</span>
			);
		},

		render: function() {
			var me = this, props = me.props, boxStyle, title;

			if (props.checked) {
				boxStyle = Object.assign({}, style.base, style.checked);
			}

			if (props.showTitle) {
				title = me.getTitle();
			}

			return (
				<div style={props.style ? [style.wrapper, props.style] : style.wrapper}>
					{title}
					<Checkbox {...props} Sign={Sign} customBoxStyle={boxStyle || style.base} />
				</div>
			);
		}

	})
);


// WEBPACK FOOTER //
// ./src/components/Toggle/Toggle.jsx